module.exports = __webpack_public_path__ + "static/media/inu.d1a548fe.png";